import { CHANGE_FONTSIZE } from "./index";

import {
  FETCH_EMPLOYEE_SUCCESS,
  FETCH_BLOCKEDNUMBERS_SUCCESS,
  FETCH_VOICEMAILDESTINATION_SUCCESS,
  FETCH_AUDITLOGS_SUCCESS,
  FETCH_PAYMENTINFO_SUCCESS,
  FETCH_SETTING_ERROR,
  FETCH_SETTING_LOADING,
  FETCH_AI_SETTINGS_SUCCESS,
  FETCH_AI_SETTINGS_LOADING,
  FETCH_AI_SETTINGS_ERROR,
  UPDATE_AI_SETTINGS_SUCCESS,
  UPDATE_GOOGLE_CALENDAR_NAME,
  DELETE_GOOGLE_CALENDAR,
  FETCH_GOOGLE_CALENDARS_LOADING,
  FETCH_GOOGLE_CALENDARS_SUCCESS,
  FETCH_GOOGLE_CALENDARS_ERROR,
} from "./index";

import { apiCall } from "../../functions/utils";

export const fetchEmployeeSuccess = (data) => {
  return {
    type: FETCH_EMPLOYEE_SUCCESS,
    payload: data,
  };
};

export const fetchAuditLogsSuccess = (data) => {
  return {
    type: FETCH_AUDITLOGS_SUCCESS,
    payload: data,
  };
};
export const fetchPaymentInfoSuccess = (data) => {
  return {
    type: FETCH_PAYMENTINFO_SUCCESS,
    payload: data,
  };
};

export const changeFontSize = (data) => {
  return {
    type: CHANGE_FONTSIZE,
    payload: data,
  };
};

export const fetchBlockedNumbersSuccess = (data) => {
  return {
    type: FETCH_BLOCKEDNUMBERS_SUCCESS,
    payload: data,
  };
};

export const fetchVoicemailDestinationSuccess = (data) => {
  return {
    type: FETCH_VOICEMAILDESTINATION_SUCCESS,
    payload: data,
  };
};

export const fetchSettingError = (error) => {
  return {
    type: FETCH_SETTING_ERROR,
    error,
  };
};

export const fetchSettingLoading = () => {
  return {
    type: FETCH_SETTING_LOADING,
  };
};

export const fetchAiSettingsLoading = () => {
  return {
    type: FETCH_AI_SETTINGS_LOADING,
  };
};

export const fetchAiSettingsSuccess = (data) => {
  return {
    type: FETCH_AI_SETTINGS_SUCCESS,
    payload: data,
  };
};

export const fetchAiSettingsError = (error) => {
  return {
    type: FETCH_AI_SETTINGS_ERROR,
    error,
  };
};

export const updateAiSettingsSuccess = (data) => {
  return {
    type: UPDATE_AI_SETTINGS_SUCCESS,
    payload: data,
  };
};

export const fetchEmployees = () => {
  return async (dispatch) => {
    dispatch(fetchSettingLoading());
    try {
      const res = await apiCall(true, "GET", `/api/employees`);
      dispatch(fetchEmployeeSuccess(res.data));
    } catch (e) {
      dispatch(fetchSettingError(e));
    }
  };
};
export const fetchBlockedNumbers = () => {
  return async (dispatch) => {
    //dispatch(fetchSettingLoading())
    try {
      const res = await apiCall(true, "GET", `/api/blocked-numbers`);
      dispatch(fetchBlockedNumbersSuccess(res.data));
    } catch (e) {
      //  dispatch(fetchSettingError(e))
    }
  };
};

export const deleteBlockedNumber = (id) => {
  return async (dispatch) => {
    dispatch(fetchSettingLoading());
    try {
      const res = await apiCall(
        true,
        "DELETE",
        `/api/blocked-numbers/${id}`,
        {}
      );
      dispatch(fetchBlockedNumbers());
    } catch (e) {
      dispatch(fetchSettingError(e));
    }
  };
};

export const addBlockedNumber = (new_number) => {
  return async (dispatch) => {
    dispatch(fetchSettingLoading());
    try {
      const res = await apiCall(
        true,
        "POST",
        `/api/blocked-numbers`,
        new_number
      );
      dispatch(fetchBlockedNumbers());
    } catch (e) {
      dispatch(fetchSettingError(e));
    }
  };
};

export const addNewEmployee = (new_employee) => {
  return async (dispatch) => {
    dispatch(fetchSettingLoading());
    try {
      if (new_employee.id) {
        await apiCall(
          true,
          "PUT",
          `/api/employees/${new_employee.id}`,
          new_employee
        );
      } else {
        await apiCall(true, "POST", `/api/employees`, new_employee);
      }
      dispatch(fetchEmployees());
    } catch (e) {
      dispatch(fetchSettingError(e));
    }
  };
};

export const deleteEmployee = (id) => {
  return async (dispatch) => {
    dispatch(fetchSettingLoading());
    try {
      await apiCall(true, "DELETE", `/api/employees/${id}`, {});
      dispatch(fetchEmployees());
    } catch (e) {
      dispatch(fetchSettingError(e));
    }
  };
};

export const fetchVoicemailDestination = () => {
  return async (dispatch) => {
    // dispatch(fetchSettingLoading())
    try {
      const res = await apiCall(true, "GET", `/api/transcripts`);
      dispatch(fetchVoicemailDestinationSuccess(res.data));
    } catch (e) {
      // dispatch(fetchSettingError(e))
    }
  };
};

export const deleteVoicemailDestination = (id) => {
  return async (dispatch) => {
    dispatch(fetchSettingLoading());
    try {
      const res = await apiCall(true, "DELETE", `/api/transcripts/${id}`, {});
      dispatch(fetchVoicemailDestination());
    } catch (e) {
      dispatch(fetchSettingError(e));
    }
  };
};

export const addNewVoicemailDestination = (new_email) => {
  return async (dispatch) => {
    dispatch(fetchSettingLoading());
    try {
      const res = await apiCall(true, "POST", `/api/transcripts`, new_email);
      dispatch(fetchVoicemailDestination());
    } catch (e) {
      dispatch(fetchSettingError(e));
    }
  };
};

export const fetchAuditLogs = (filters) => {
  return async (dispatch) => {
    // dispatch(fetchSettingLoading())
    try {
      const res = await apiCall(true, "POST", `/api/audit-logs`, filters);
      console.log(res);
      dispatch(fetchAuditLogsSuccess(res.data));
    } catch (e) {
      // dispatch(fetchSettingError(e))
    }
  };
};

export const fetchPaymentInfo = () => {
  return async (dispatch) => {
    // dispatch(fetchSettingLoading())
    try {
      const res = await apiCall(true, "GET", `/api/payments`);
      console.log(res);
      dispatch(fetchPaymentInfoSuccess(res.data));
    } catch (e) {
      // dispatch(fetchSettingError(e))
    }
  };
};

export const fetchAiSettings = () => {
  return async (dispatch) => {
    // we want loader specifically for AI tab
    dispatch(fetchAiSettingsLoading());

    try {
      const res = await apiCall(true, "GET", `/api/ai-settings`);
      // backend returns { status, message, data: {...} }
      dispatch(fetchAiSettingsSuccess(res.data.data));
    } catch (e) {
      dispatch(fetchAiSettingsError(e));
    }
  };
};

export const updateAiSettings = (payload) => {
  return async (dispatch) => {
    // could reuse same loading state for now
    dispatch(fetchAiSettingsLoading());

    try {
      const res = await apiCall(true, "PUT", `/api/ai-settings`, payload);
      // backend returns { status, message, data: {...} }
      dispatch(updateAiSettingsSuccess(res.data.data));
    } catch (e) {
      dispatch(fetchAiSettingsError(e));
    }
  };
};

export const updateGoogleCalendarName = (
  connectionId,
  calendarId,
  friendlyName
) => {
  return async (dispatch) => {
    try {
      const res = await apiCall(true, "POST", "/api/google/calendars/update", {
        connectionId,
        calendarId,
        friendly_name: friendlyName,
      });

      dispatch({
        type: UPDATE_GOOGLE_CALENDAR_NAME,
        payload: { connectionId, calendarId, friendlyName },
      });

      return res;
    } catch (e) {
      console.error("Failed to update calendar name:", e);
      throw e;
    }
  };
};

export const deleteGoogleCalendar = (connectionId, calendarId) => {
  return async (dispatch) => {
    try {
      const res = await apiCall(true, "POST", "/api/google/calendars/delete", {
        connectionId,
        calendarId,
      });

      dispatch({
        type: DELETE_GOOGLE_CALENDAR,
        payload: { connectionId, calendarId },
      });

      return res;
    } catch (e) {
      console.error("Failed to delete calendar:", e);
      throw e;
    }
  };
};

export const fetchGoogleCalendars = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_GOOGLE_CALENDARS_LOADING });

    try {
      const res = await apiCall(true, "GET", "/api/google/calendars");

      dispatch({
        type: FETCH_GOOGLE_CALENDARS_SUCCESS,
        payload: res?.data?.connections || [],
      });
    } catch (e) {
      dispatch({
        type: FETCH_GOOGLE_CALENDARS_ERROR,
        error: e,
      });
    }
  };
};

export const disconnectGoogleCalendar = (connectionId) => {
  return async (dispatch) => {
    await apiCall(true, "POST", "/api/google/disconnect", {
      connectionId,
    });

    // Refresh calendar connections list
    dispatch(fetchGoogleCalendars());
  };
};
